export const locale = {
    lang: 'zh2',
    data: {
      'ALERTS':{
        'OK':'好'
      },
      'SHEDULE': {
        'TITLE1':	'登记开始日期',
        'TITLE2':	'输入提醒',
        'TITLE3':	'注册完结日期',
        'ERR01':'提醒不可少于发布日',
        'ERR02':'提醒不能大于结束日',
        'ERR03':'提醒必须在调查过程中',
        'ERR04':'您只能有3条提醒',
        'ERR05':'日期不能低于现在',
        'ERR06':'您今天已经发送了一封电子邮件',
        'SUC01':'提醒保存',
        'SELECT_DATE':	'选择一个日期',
        'SAVE':	'储存',
        'RECORDATORIOS':	'提醒电邮',
        'RECORDATORIO':	  '温馨提示',
        'ERRORDATE':'日期不能小于当前日期',
        'SAMEDATE':'选择当前日期作为调查的开始日期是不允许的',

        'LESSDAYS_T':'您确定要继续吗？',
        'LESSDAYS_I':'您需要将调查的发布日期安排在发布前至少15天，以便协作者获得完整的沟通计划。',
        'CONFLDATE_T':'警告！',
        'CONFLDATE_I':'如果继续，则无法还原调查启动日期编程。',
        'WARNING_FECHA_UPDATE':'您无法选择今天的日期或之前的日期',
        'FECHA_UPDATE_WARNING':'请务必更改结束日期',
        'FECHA_UPDATE':'截止日期已正确更新',

        'FECHA':	'日期',
        'AGREGAR':	'新增',
        'EDITAR':	'编辑',
        'COMPLETAR_PASO':	'完成此步骤',
        'PASO_COMPLETADO':	'此步骤已完成',
        'SUBIRLOGO': '要创建调查，您需要上传公司徽标',
        'ACEPTARREQUERIMIENTOS': '要创建调查，必须接受技术要求',
        'LOGOSSURVEY': '要创建您的调查，有必要首先建立必要的标志',
        'SELECCIONE_FECHA': '请选择一个日期',
        'DATE_REGISTERED': '启动日期已成功注册',
        'CLOSE_REGISTERED': '截止日期已成功注册',
        'CLOSE_MSJ1': '截止日期必须大于发布日期',
        'CLOSE_MSJ2': '注册关闭之前，您必须注册发布日期',
        'REMIDEROK': '提醒已正确注册',
        'REMIDERUPDAOK': '提醒已成功更新',
        'AVIUPDAOK': '正确更新通知',
        'REMIDER_MSJ1': '提醒必须大于发布日期',
        'REMIDER_MSJ2': '在注册提醒之前，您必须注册发布日期',

        'ENCUESTA': '调查表',
        'CREANDO_ENCUESTA': '创建调查...',
        'AGREGANDO_USUARIOS': '添加用户...',
        'AGREGANDO_SECCION1': '将NPS添加到调查中...',
        'AGREGANDO_SECCION2': '在调查中添加报表...',
        'AGREGANDO_SECCION3': '为调查增加控制...',
        'AGREGANDO_SECCION4': '将人口统计信息添加到调查中...',
        'AGREGANDO_SECCION5': '在调查中添加其他内容...',
        'AGREGANDO_SECCION6': '在调查中添加全民实践...',
        'AGREGANDO_SECCION7': '將 公开问题 添加到調查中...',
        'ERROR_SECCION7': '將 公开问题 添加到調查時出錯...',

        'REINTENTAR': '重试',
        'ERROR_ENCUESTA': '创建调查时出错',
        'ERROR_USUARIOS': '添加用户时出错...',
        'ERROR_SECCION1': '将NPS添加到调查时出错...',
        'ERROR_SECCION2': '向调查中添加语句时出错...',
        'ERROR_SECCION3': '将控件添加到调查时出错...',
        'ERROR_SECCION4': '将受众特征添加到调查中时出错...',
        'ERROR_SECCION5': '在调查中添加其他内容时出错...',
        'ERROR_SECCION6': '将“所有实务”添加到调查中时出错...',

        'SUCCESS_ENCUESTA': '调查成功创建!',
        'SUCCESS_USUARIOS': '用户添加成功!',
        'SUCCESS_SECCION1': 'NPS已成功添加到调查中！',
        'SUCCESS_SECCION2': '报表已成功添加到调查中！',
        'SUCCESS_SECCION3': '控制问题已成功添加到调查中！',
        'SUCCESS_SECCION4': '受众特征已成功添加到调查中！',
        'SUCCESS_SECCION5': '附加功能已成功添加到调查中！',
        'SUCCESS_SECCION6': '将所有实践成功添加到调查中！',
        'SUCCESS_SECCION7': '未解决的问题已成功添加到调查中！',
        'BTN_CREARENCUESTA': '创建调查',
        'CONTINUE_FINISH': '调查创建成功，您可以完成此步骤。',
        'LAUNCH_SURVEY': '请创建调查以完成此步骤',
        'PULSE':{
          //Shedule survey
          'MES1': ' Pulse Check月 1',
          'MES2': ' Pulse Check月 2',
          'MES3': ' Pulse Check月 3',
          'MES4': ' Pulse Check月 4',
          'MES5': ' Pulse Check月 5',
          'MES6': ' Pulse Check月 6',
          'MES7': ' Pulse Check月 7',
          'MES8': ' Pulse Check月 8',
          'MES9': ' Pulse Check月 9',
          'MES10': ' Pulse Check月 10',
          'MES11': ' Pulse Check月 11',
          'MES12': ' Pulse Check月 12',
          'EDITAR': '加',
          'INDICA': '选择脉搏检查日期',
          'INDICA_GENERA':'生成调查',
          'SUBINDICA_GENERA':'单击以生成调查',

        },

      },
      'SHEDULE2_0': {
        'CARDS': {
          'PASO1': {
            'TITULO': '先决条件',
            'INFO_PRE': '创建调查之前，您需要先满足这些先决条件',
            'INFO_POST': '您已经满足创建调查的前提条件',
            'REQTEC': '技术要求',
            'REQTEC_TOOLTIP': '转到技术要求',
            'LOGO': '公司标志',
            'LOGO_TOOLTIP': '单击以加载徽标'
          },
          'PASO2': {
            'TITULO': '发布日期',
            'TITULO_CIERRE': '截止日期',
            'INFO_PRE': '选择并记录调查的启动日期',
            'INFO_POST': '选定日期',
            'INFO_POST_CIERRE': '截止日期',
            'PICKDATE': '打开日历',
            'CHANGE': '改变日期',
            'LIS-PRORRO':'扩展名',
          },
          'PASO2_B': {
            'TITULO': '日期选择',
            'INFO_PRE': '选择并注册可用于配置调查的不同日期',
            'PICKDATE': '选择日期',
            'INFO_PROR': '扩展已分配给该产品',
            'PRORROGAS': '查看扩展',
            'TIUTLOLISTA': '创建扩展',
            'NOPROR': '您没有分配的扩展'
          },
          'PASO3': {
            'TITULO': '提醒事项',
            'INFO_PRE': '添加提醒提交日期以回答调查',
            'INFO_POST': '您有两个选择：',
            'NUEVO': '注册新提醒',
            'LISTA': '记录的提醒',
            'LISTA_AVI': '调查前沟通',
            'TITU_AVIS':'广告',
            'TIUTLOLISTA': '提醒已创建',
            'NORECOS': '您尚未保存任何提醒',
            'NOAVI': '您还没有保存任何警告',
            'INFOHORA': '注意：每个提醒都显示在研究所的本地时间：',
            'INFOHORAAVISO': '注意：每条公告均以研究所当地时间显示：',
             'TITULOLISTA': '通知已创建',
          },
          'PASO4': {
            'TITULO': '通讯讯息',
            'INFO_PRE': '查看调查生命周期中要发送的通信消息',
            'VERMENSAJES': '查看通讯讯息'
          },
          'PASO5': {
            'TITULO': '调查检查',
            'TITULO_ALT': '主表检查',
            'INFO_PRE': '查看调查的各个部分，以及每个部分中添加的问题数',
            'VERMENSAJES': '查看部分数据',
            'FILTRAR': '按名称过滤部分',
            'TABLE':{
              'SECTION': '部分',
              'VALUE': '值',
            }
          },
          'PASO6': {
            'TITULO': '调查生成历史',
            'INFO_PRE': '上次调查生成日期:',
            'INFO_PRE_2': '产生历史:',
          },
          'PASO7': {
            'TITULO': '调查特点',
            'INFO_PRE': '在配置调查功能之前，您需要先完成先决条件',
            'INFO_POST_1': '在创建调查之前，有必要配置调查的特征',
            'INFO_POST_2': '您已经设置了创建调查所需的设置',
            'EMPRESA': '公司标志',
            'CERTIFICADO': '证书标志',
            'CARACTERISTICAS': '调查特点',
            'PREVIEW': '预习',
            'CAMBIAR': '更改图像',
            'LOGO_EMP_INFO': '图像以其保存的分辨率显示，200x200 像素'
          },
          'MODALGEN': {
            'REGRESAR': '回去',
            'HISTORIAL': {
              'BOTON': '调查生成历史',
              'TITULO': '调查生成历史',
              'CARGANDO': '加载生成历史',
              'ULTIMA': '上一代日期',
              'ANTERIORES': '上一代日期',
              'NOHISTO': '没有调查的生成历史'
            },
            'CERTIFICADO': {
              'TITULO': '证书预览'
            },
            'URL_QR': {
              'BOTON': '获取二维码链接',
              'TITULO': '二维码中的调查链接',
              'SUBTITULO': '通过扫描此二维码，您可以直接访问调查，而无需手动输入链接',
              'DESCARGA': '要下载二维码，请右键单击图像，然后单击 <b> <em> 将图像另存为 ... </em> </b> 选项',
              'REGENERARQR': 'URL 已正确修改，如果您有上一个 URL 的二维码，则需要使用更新后的链接获取新的二维码'
            }
          },
          'STATUS': {
            'PENDING': '尚未完成',
            'OK': '准备',
            'OPT': '此步骤是可选的'
          },
          'FECHAS': {
            'TITULO': '日期选择',
            'FECHA': '选定日期：',
            'NOTYET': '尚未选择',
            'INFO': {
              '1': '选择每个可用日期以配置调查。',
              '2': '注意：在每个日期选择的时间设置为研究所的当地时间：'
            },
            'TABLA': {
              'TIPO': '日期类型',
              'FECHA': '选定日期',
              'ACCIONES': '动作'
            },
            'TIPOS': {
              'lanzamiento': '发射日期',
              'aviso1': '启动前（调查启动前的第一个通知）',
              'aviso2': '启动前（启动调查前的第二次通知）',
              'cierre': '最后期限',
              'recor30': '预发布（调查前 30 天通知）',
               'registro29': '预发布（调查前 29 天通知）',
               'recor15': '预发布（调查前 15 天通知）',
               'recor7': '预发布（调查前 7 天通知）',
               'result':'结果：',
            },
            'BOTONES': {
              'ELEGIR': '选择日期',
              'CAMBIAR': '改变日期',
              'CANCELAR': '取消',
              'ACEPTAR': '接受',
              'ENVIOCIERRE': '发送通知'
            }
          }
        },
        'CREAR': '创建调查',
        'RECREAR': '重新创建调查',
        'ENCUESTACREADA': '调查已创建',
        'ENCUESTAERROR': '调查未正确创建',
        'VERSECCIONES': '查看添加的部分',
        'BACK': '背部',
        'CERRAR': '关',
        'CREANDO': '正在创建调查，请等待，直到正确添加了每个组件',
        'RETRY': '重试该过程',
        'SECCIONES': {
          'DETALLES': '保存最后的详细信息',
          'COMPLETA': '调查已成功创建！',
          'ENCUESTA': {
            'TITULO': '调查',
            'PROCESO': '创建调查',
            'ERROR': '创建调查时发生错误，请重试该过程'
          },
          'USUARIOS': {
            'TITULO': '用户数',
            'PROCESO': '将用户添加到调查中',
            'ERROR': '添加用户时发生错误，请重试该过程',
          },
          'NPS': {
            'TITULO': 'NPS',
            'PROCESO': '将NPS添加到调查中',
            'ERROR': '添加NPS时发生错误，请重试此过程',
          },
          'REACTIVOS': {
            'TITULO': '陈述',
            'PROCESO': '在调查中添加报表',
            'ERROR': '添加语句时发生错误，请重试该过程',
          },
          'CONTROL': {
            'TITULO': '控制问题',
            'PROCESO': '向调查中添加控制问题',
            'ERROR': '添加控制问题时发生错误，请重试该过程',
          },
          'DEMOGRAFICOS': {
            'TITULO': '客层',
            'PROCESO': '将人口统计信息添加到调查中',
            'ERROR': '添加受众特征时发生错误，请重试此过程',
          },
          'ABIERTAS': {
            'TITULO': '公开问题',
            'PROCESO': '向调查中添加未解决的问题',
            'ERROR': '添加未解决的问题时发生错误，请重试此过程',
          },
          'FORALL': {
            'TITULO': '对所有人',
            'PROCESO': '将ForAll做法添加到调查中',
            'ERROR': '添加ForAll练习时发生错误，请重试该过程',
          },
          'ADICIONALES': {
            'TITULO': '额外',
            'PROCESO': '向调查中添加其他问题',
            'ERROR': '添加其他问题时发生错误，请重试该过程',
          },
          'ADICIONALES-FOCUS': {
            'TITULO': '个性化',
            'PROCESO': '向调查中添加自定义问题',
            'ERROR': '添加自定义问题时发生错误，请重试该过程',
          },
        },
        'MODALES': {
          'ENCUESTA': {
            'CREAR_1': '您要使用当前配置创建调查吗？',
            'CREAR_2': '创建调查后，您将无法修改通讯消息',
            'CREAR_3': '您要开始创建调查吗',
            'SINFECHA': '要创建调查，必须首先选择该调查的启动日期',
            'CREADA_1': '调查已成功创建！',
            'CREADA_2': '现在，您可以完成本节并继续下一个',
            'RECOEXIS': '所选日期已经有注册提醒',
            'RECOBEFORE': '您必须先选择调查的开始日期才能记录提醒',
            'RECOMAX': '您已经设置了所有允许的提醒，无法再注册新的提醒',
            'LASTRECO_1': '警告：',
            'LASTRECO_2': '您已经安排了所有允许的提醒，因此您将无法再注册新的提醒',
            'LISTARECOBEF': '您必须先选择调查的开始日期才能查看提醒列表',
            'FINAL': '现在，您可以完成本节并继续下一个',
            'SAVELAUNCHDATE': '正在保存调查启动日期，请稍等',
            'SAVEAVISODATE': '保存通知日期，请稍等',
            'AVISOOK': '通知日期已成功保存',
            'CHANGELAUNCH': '警告：如果更改调查的开始日期，其余日期将被删除，您将不得不再次选择它们，您是否要选择另一个开始日期？',
            'CHANGECLOSENOT': '通知发送状态已成功更改',
            'GUARDANDO_LOGO': '正在保存图片，请稍等',
            'CARGA_CERT': '要在最终文档中获得最高质量，请务必上传最小分辨率为 400 x 240 像素的图像。',
            'BORRA_RECO_1': '您确定要删除以下日期的提醒吗？',
            'BORRA_RECO_2': '已成功删除提醒',
            'BORRA_AVI_1': '您确定要删除以下日期的提醒吗？',
            'BORRA_AVI_2': '提醒已成功提醒',
            'UPDA_AVISO':'更新提醒日期',
            'UPDA_RECOR':'更新提醒日期',
            'DELE_AVISO':'删除提醒日期',
            'DELE_RECOR':'删除提醒日期',
            'GUARD_RECOR':'保存提醒日期',
            'TITL_MOD_QUES_ALEAT':'要创建调查，必须启用随机问题验证',
            'TEXT_MOD_QUES_ALEAT_1':'然后执行以下步骤：',
            'TEXT_MOD_QUES_ALEAT_2':'1.- 输入编辑调查特征。',
            'TEXT_MOD_QUES_ALEAT_3':'2.-点击附加配置并启用随机问题验证',
          }
        },
        'CORREOS': {
          'VER': '查看讯息',
          'TIPO1': {
              'TITULO': '发布前消息',
              'INFO': '这些是在调查启动前几天发送的消息',
              'TIPO_1': '第一条通知消息',
              'TIPO_2': '第二条通知消息',
          },
          'TIPO2': {
              'TITULO': '邀请讯息',
              'INFO': '这是在调查启动之日发送给协作者的消息'
          },
          'TIPO3': {
              'TITULO': '提醒讯息',
              'INFO': '这是为此目的在预定日期发送的提醒消息'
          },
          'TIPO4': {
              'TITULO': '第一条通知消息',
              'INFO': ''
          },
          'TIPO5': {
              'TITULO': '第二条通知消息',
              'INFO': ''
          },
          'TIPO6': {
              'TITULO': '调查结束讯息',
              'INFO': '这是在调查结束日期发送给协作者的消息\n注意：仅在激活后才发送'
          },
          'TIPO7': {
            'TITULO': '给尚未开始调查的合作者的消息',
            'INFO': '这是发送给尚未开始调查的合作者的提醒消息'
          },
          'TIPO8': {
            'TITULO': '给尚未完成的合作者的消息',
            'INFO': '这是向已开始调查但尚未完成调查的参与者发送的提醒消息'
          },
        },
        'EDITOR': {
          'BOTONES': {
            'INFO': '重要信息',
            'SAVE': '保存更改',
            'EDIT': '编辑讯息',
          },
          'PENDING': '验证过程中',
          'MODALINFO': {
            'TITULO': '有关电子邮件内容的重要信息',
            'PARTE_1': '为了使电子邮件被认为是正确的，可以在邮件正文中包含以下标签（注意，必须至少包含一次强制标签）：',
            'PARTE_2': '其原因是由于以下事实：当每封电子邮件的传递日期到达时，平台会在消息中自动执行以下替换：',
            'tag_company': '公司名称',
            'tag_link': '访问调查的链接',
            'tag_date': '调查的开始日期',
            'tag_user': '调查访问密码',
            'tag_dtb': '距调查启动的天数（从发送消息的日期开始）',
            'tag_dtc': '直到调查结束的天数（从发送消息的日期开始）',
            'tag_end': '调查的截止日期',
            'tag_userAction': '用户登录',
            'tag_pass': '用户密码',
            'tag_linkAction': '文化围棋的访问链接',
            'PARTE_3': '标签可以放置在电子邮件正文中的任何位置。一旦标签出现在内容中，就可以保存',
            'PARTE_4': '注意：消息可能需要由项目经理进行验证，在这种情况下，您将能够在此屏幕上看到新电子邮件的验证状态。 在验证过程中，您将无法制作新版本的电子邮件。 否则，该电子邮件将立即被视为有效，并且您可以根据需要再次对其进行编辑。',
            'OPC': '（可选）',
            'MDT': '（必填项，关闭消息中除外）'
          },
          'MODALES': {
            'SINCAMBIOS': '您尚未更改电子邮件的内容',
            'SINTAG': '无法保存邮件，找不到下一个标签：',
            'GUARDAR_1': '您要保存对消息所做的更改吗？',
            'GUARDAR_2': '我们提醒您，它将被发送以进行验证，直到验证过程结束，您将无法对其进行重新编辑。',
            'SAVEOK_1': '电子邮件内容已正确保存',
            'SAVEOK_2': '等待项目经理确认修改',
            'ENABLED': '项目经理已重新激活电子邮件编辑，您可以继续进行修改',
            'CAMBIOIDIOMA_1': '警告：如果您要选择其他语言，则必须先保存当前对当前语言所做的更改',
            'CAMBIOIDIOMA_2': '您要保存更改并选择另一种语言吗？',
          }
        },
        'ZONAS': {
          '1': '墨西哥城',
          '2': '圣萨尔瓦多',
          '3': '香港',
          '4': '新加坡',
          '5': '伊斯坦堡',
          '6': '马尼拉',
          '11': '巴西利亚',
          '15': '马德里',
          '18': '墨西哥城',
        },
        'SECCIONES_ESPECIALES': {
          'TITULO': '本次调查有专门的部分',
          'SUBTITULO': '以下是分组的演示用户，每个组旨在单独测试带有每个特殊部分的调查，或者没有特殊部分的调查',
          'ELEGIR': '从左侧菜单中选择一个组',
          'LISTA': {
            'TITULO': '特殊部分',
            'SIN_SECCION': '无特殊部分的调查'
          }
        },
        'CORREOS_NORM':{
          'TIPO1':{
            'TITULO': '发布前消息',
            'INFO': '这些是在调查启动前几天发送的消息',
          },
          'TIPO2':{
            'TITULO': '警告信息：邀请发布前 30 天' ,
            'INFO': '这些是调查开始前几天发送的消息'
          },
          'TIPO3':{
            'TITULO': '警告信息：邀请发布前 29 天',
            'INFO': '这些是调查开始前几天发送的消息'
          },
          'TIPO4':{
            'TITULO': '警告信息：邀请发布前 15 天',
            'INFO': '这些是调查开始前几天发送的消息'
          },
          'TIPO5':{
            'TITULO': '警告信息：邀请发布前 7 天',
            'INFO': '这些是调查开始前几天发送的消息'
          },
          'TIPO6': {
              'TITULO': '调查结束讯息',
              'INFO': '这是在调查结束日期发送给协作者的消息\n注意：仅在激活后才发送'
          },
          'TIPO7':{
            'TITULO': '提醒讯息',
            'INFO': '这是为此目的在预定日期发送的提醒消息'
          },
        }
      }


    }
};
// simplificado
